import React, { useCallback } from "react";
import { Footer } from "@bloomberg/media-ui-nav";
import type { SubmenuItem } from "@bloomberg/media-ui-nav/dist/types";
import { trackClickEvent } from "@foundation/nextjs-gtm";
import styles from "./footer.module.css";
import { Locale } from "~constants/i18n";
import { localeMap } from "~utils/i18n/localeMap";

interface NavFooterProps {
  footerMenuItems?: Record<string, SubmenuItem>;
  locale?: string;
}

const addPrivacyManager = (link: HTMLButtonElement) => {
  window.cmpClient.cmd.push(() => {
    const cmpClient = window.getCmpClient();

    cmpClient.addPrivacyManager(link);
  });
};

export default function NavFooter({
  footerMenuItems,
  locale = Locale.En,
}: NavFooterProps) {
  const trackingFunction = useCallback(
    (eventAction: string, eventLabel: string) => {
      trackClickEvent("footerClick", eventLabel, eventAction);
    },
    []
  );

  // Footer media-ui-nav expects jp - convert 'ja' to 'jp'
  const routeLocale =
    localeMap[locale as keyof typeof localeMap]?.routeLocale || locale;

  return (
    <Footer
      addPrivacyManager={addPrivacyManager}
      name="footer"
      footerMenuItems={footerMenuItems}
      trackingFunction={trackingFunction}
      desktopBreakpointClassName={styles.gridFooter}
      locale={routeLocale}
    />
  );
}
